import React from 'react';
import { useTranslation } from 'react-i18next';
import { PACKAGE_TYPE } from '@src/constants/package';
import { StyledPackageTypes } from './index.style';

const PackageTypes = ({
  isSMSUser,
  types,
  activeType,
  onChangeType,
  useNewPackagesTab,
  useRenameMergeProduct,
}) => {
  const customActiveType =
    useRenameMergeProduct && activeType === PACKAGE_TYPE.DUBBING
      ? PACKAGE_TYPE.STUDIO
      : activeType;
  const { t } = useTranslation();

  return (
    <StyledPackageTypes
      useNewPackagesTab={useNewPackagesTab}
      isSMSUser={isSMSUser}
    >
      {types.map((packageType) => (
        <div
          role="button"
          tabIndex={0}
          onClick={() => onChangeType(packageType.id)}
          className={`package-tab ${
            packageType.id === customActiveType ? 'package-active-tab' : ''
          }`}
          data-id="select-pricing-product"
          data-product={packageType?.id}
        >
          {t(packageType.label)}
        </div>
      ))}
    </StyledPackageTypes>
  );
};

export default PackageTypes;
